export default __webpack_public_path__ + "static/media/date_picker_icon2.566d67ef.svg";